import React, { useState, useMemo, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { withRouter, Link } from 'react-router-dom';
import {
    Container,
    Button,
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Alert
} from "reactstrap";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
    getPeriodById as onGetPeriod,
    updatePeriod as onUpdatePeriod,
    addNewPeriod as onAddPeriod,
    getCompanies as onGetCompanies
} from "../../store/actions";

import * as Yup from "yup";
import { useFormik } from "formik";

import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";
import CurrencyFormat from 'react-currency-format';

const PeriodCreateUpdate = (props) => {

    //meta title
    document.title = "Period | Des Counts";
    const id = props?.match?.params?.id;
    const companyId = props?.match?.params?.companyId;
    const isEdit = id != undefined && companyId != undefined;
    const [taxValue, setTaxValue] = useState(0)

    const { companies, period, loading, error } = useSelector(state => ({
        companies: state.Company.companies,
        period: state.Period.period,
        loading: state.Period.loading,
        error: state.Period.error,
    }));

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e)
        validation.setFieldValue("companyId", e.value.toString(), true)
    }

    const dispatch = useDispatch();
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            companyId: isEdit && period ? period.companyId : "",
            code: isEdit && period ? period.code : "",
            name: isEdit && period ? period.name : "",
            tax: isEdit && period ? period.tax : 0,
        },
        validationSchema: Yup.object({
            companyId: Yup.string().required("Please Select company"),
            code: Yup.string().required("Please Enter Code"),
            name: Yup.string().required("Please Enter Period Name"),
            tax: Yup.number().required("Please Enter Tax").nullable(),
        }),
        onSubmit: (values) => {
            if (isEdit) {
                dispatch(onUpdatePeriod({ id: period.id, companyId: period.companyId, code: values.code, name: values.name, tax: values.tax }, props.history));
            } else {
                dispatch(onAddPeriod({
                    code: values.code,
                    name: values.name,
                    tax: values.tax,
                    companyId: parseInt(values.companyId)
                }, props.history));
            }
        },
    });

    function handleChangeTax(e) {
        setTaxValue(e.floatValue)
        validation.setFieldValue("tax", e.floatValue, true)
    }

    useEffect(() => {
        dispatch(onGetCompanies({}))
        if (isEdit) {
            dispatch(onGetPeriod(id, companyId))
        }
    }, [dispatch])

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id.toString() }
            }))
        }
    }, [companies])

    useEffect(() => {
        if (period) {
            setTaxValue(period.tax)
            validation.setFieldValue("tax", period.tax, true)
        }
    }, [period])

    useEffect(() => {
        if (isEdit && period && companies) {
            var company = optionCompany.filter(s => s.value == period.companyId);
            if (company.length > 0) {
                setSelectedCompany(company[0])
            }
        }
    }, [optionCompany])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Master Data" breadcrumbItem={(isEdit ? "Edit" : "Add") + " Period"} />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    {
                                        !loading &&
                                        <>
                                            <Row>
                                                <Col>
                                                    <Form
                                                        className="form-horizontal"
                                                        onSubmit={(e) => {
                                                            e.preventDefault();
                                                            validation.handleSubmit();
                                                            return false;
                                                        }}
                                                    >
                                                        <Row>
                                                            <Col sm={6}>
                                                                <div className="mb-3">
                                                                    <Label>Company</Label><Label className="text-danger">*</Label>
                                                                    <div
                                                                        style={validation.errors.companyId ? { border: '1px solid #f46a6a', borderRadius: '0.25rem' } :
                                                                            { border: '0', borderRadius: '0.25rem' }}
                                                                    >
                                                                        <Select
                                                                            value={selectedCompany}
                                                                            onChange={handleSelectCompany}
                                                                            onBlur={validation.handleBlur}
                                                                            options={optionCompany}
                                                                            isDisabled={isEdit}
                                                                            className="select2-selection"
                                                                        />
                                                                    </div>
                                                                    {validation.touched.companyId && validation.errors.companyId ? (
                                                                        <FormFeedback className="d-block" type="invalid">Please select company</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                            <Col sm={6}>
                                                                <div className="mb-3">
                                                                    <Label className="form-label">Code</Label><Label className="text-danger">*</Label>
                                                                    <Input
                                                                        name="code"
                                                                        className="form-control"
                                                                        placeholder="Enter period code"
                                                                        type="text"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.code || ""}
                                                                        invalid={
                                                                            validation.touched.code && validation.errors.code ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.code && validation.errors.code ? (
                                                                        <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                        </Row>

                                                        <Row>
                                                            <Col sm={6}>
                                                                <div className="mb-3">
                                                                    <Label className="form-label">Name</Label><Label className="text-danger">*</Label>
                                                                    <Input
                                                                        name="name"
                                                                        className="form-control"
                                                                        placeholder="Enter period name"
                                                                        type="text"
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.name || ""}
                                                                        invalid={
                                                                            validation.touched.name && validation.errors.name ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.name && validation.errors.name ? (
                                                                        <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                            <Col sm={6}>
                                                                <div className="mb-3">
                                                                    <Label>Tax</Label><Label className="text-danger">*</Label>
                                                                    <CurrencyFormat thousandSeparator="." decimalSeparator="," value={taxValue}
                                                                        customInput={Input} className={(validation.touched.tax && validation.errors.tax ? " is-invalid text-end" : " text-end")}
                                                                        name="tax" onValueChange={handleChangeTax} />
                                                                    {validation.touched.tax && validation.errors.tax ? (
                                                                        <FormFeedback className="d-block" type="invalid">{validation.errors.tax}</FormFeedback>
                                                                    ) : null}
                                                                </div>
                                                            </Col>
                                                        </Row>


                                                        <div className="mt-3 mb-2">
                                                            <Link to="/masterdata/period">
                                                                <Button
                                                                    color="secondary"
                                                                    className="btn btn-secondary float-end"
                                                                >
                                                                    Cancel
                                                                </Button>
                                                            </Link>
                                                            <Button
                                                                color="primary"
                                                                className="btn btn-primary float-end me-2"
                                                                type="submit"
                                                            >
                                                                Submit
                                                            </Button>
                                                        </div>
                                                    </Form>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    {
                                        loading &&
                                        <div className="d-flex justify-content-center my-5">
                                            <PulseLoader loading={loading} color={'#FFF'} size={12} className="align-self-center" />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

PeriodCreateUpdate.propTypes = {
    history: PropTypes.object,
};

export default withRouter(PeriodCreateUpdate)
